import React from 'react';
import { ArrowDownIcon, LockIcon } from 'lucide-react';
import { CHECKOUT_URL, OFFER_ANCHOR } from '../data/config';
type CtaButtonProps = {
  children: React.ReactNode;
  mode: 'checkout' | 'scroll';
  subtext?: string;
  className?: string;
};
export function CtaButton({
  children,
  mode,
  subtext,
  className = 'max-w-[448px]'
}: CtaButtonProps) {
  const isCheckout = mode === 'checkout';
  const Icon = isCheckout ? LockIcon : ArrowDownIcon;
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} className={`mx-auto flex min-h-[50px] w-full flex-col items-center justify-center rounded-md bg-amber-400 px-4 py-2.5 text-center text-blue-950 shadow-[0_4px_0_theme(colors.amber.700)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-amber-300 active:translate-y-[2px] active:shadow-[0_2px_0_theme(colors.amber.700)] focus:outline-none focus-visible:ring-4 focus-visible:ring-teal-700/40 ${className}`} data-id="element-36" data-mp="qihahroowlmf">
      <span className="flex items-center gap-2 text-[15px] font-extrabold uppercase leading-tight md:text-[18px]" data-id="element-37" data-mp="157n6z7w57xqm">
        <Icon className="h-[18px] w-[18px] shrink-0" strokeWidth={2.75} aria-hidden data-id="element-38" data-mp="39yhm9keivbao" />
        <span className="text-balance" data-id="element-39" data-mp="3exu9w7d7wmeb">{children}</span>
      </span>
      {subtext && <span className="mt-1 text-[11px] font-semibold leading-tight" data-id="element-40" data-mp="3ezxbzprna5ze">{subtext}</span>}
    </a>;
}